export default function useAssets() {
  const ASSETS = {
    folderFull:
      "https://firebasestorage.googleapis.com/v0/b/architech-28d6b.appspot.com/o/assets%2Ffolder-full.png?alt=media&token=e50880e4-c29a-47b5-99a0-de12794f838f",
    excel:
      "https://firebasestorage.googleapis.com/v0/b/architech-28d6b.appspot.com/o/assets%2Fexcel.png?alt=media&token=995cdca0-af4e-494f-ad46-33e7899aeb0c",
    word:
      "https://firebasestorage.googleapis.com/v0/b/architech-28d6b.appspot.com/o/assets%2Fword.png?alt=media&token=e4c1e845-67fa-4adf-9f33-a13260301497",
    pdf:
      "https://firebasestorage.googleapis.com/v0/b/architech-28d6b.appspot.com/o/assets%2Fpdf.png?alt=media&token=02a23a46-54a2-4e10-87f7-78f7e731a430",
    otherFile:
      "https://firebasestorage.googleapis.com/v0/b/architech-28d6b.appspot.com/o/assets%2FotherFile.png?alt=media&token=516145f9-60ea-49f0-b6ef-d43d6f7e781a"
  };

  return {
    ASSETS
  };
}
